import React from 'react';
import { Grid, GridRow, GridColumn } from 'semantic-ui-react';
import Bold from 'components/Bold';
import { WorksheetPageIndex } from 'services/worksheet/types';
import PrintSprayWorksheetCompletionDetailsTable from './components/PrintSprayWorksheetCompletionDetailsTable';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

type Props = OwnProps;

export default class PrintSprayWorksheetCompletionDetails extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { pageIndex } = this.props;

        return (
            <div className="print-worksheet-page-section">
                <Grid columns="1">
                    <GridRow>
                        <GridColumn>
                            <Bold>Completion details</Bold>
                        </GridColumn>
                    </GridRow>
                </Grid>
                <PrintSprayWorksheetCompletionDetailsTable
                    pageIndex={pageIndex}
                />
            </div>
        );
    }
}
